import React, { FC, useState } from 'react';
import { Title, useNotify, useRefresh, useDataProvider } from 'react-admin';
import { makeStyles, Backdrop, Theme, createStyles, CircularProgress, Divider, Button, Grid, TextField, FormControlLabel, Checkbox, Box } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { useForm, SubmitHandler } from "react-hook-form";
import AndroidIcon from '@mui/icons-material/Android';
import { BASE_URL } from "../../config";

type Inputs = {
    app_version: string,
    appid: string,
    beta_version: boolean,
    description: string,
    isavailable: boolean,
    title: string,
    upgrade_min_api: string,
    upgrade_min_app_version: string,
    build: object,
};

const Create: FC = () => {

   
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const refresh = useRefresh();
    const navigate = useNavigate();

    const [openBackDrop, setOpenBackDrop] = React.useState(false);

    const [betaVersion, setBetaVersion] = useState(false);

    const handleBetaVersion = (event:any) => {
        setBetaVersion(event.target.checked);
    }

    const [isAvailable, setIsAvailable] = useState(false);

    const handleChangeIsAvailable = (event:any) => {
        setIsAvailable(event.target.checked);
    }

    const [apk, setApk] = useState<any>([]);
    const [show, setShow] = useState<boolean>(false);

    const handleAPK = (e:any) => {
        setApk(e.target.files[0]);
        setShow(true);
    }

    const { register, handleSubmit, control, watch, setValue, formState: { errors } } = useForm<Inputs>();
    const onSubmit: SubmitHandler<Inputs> = (data: any) => {
        const formData: any = new FormData();

        setOpenBackDrop(true);
        data.build = apk;

        formData.append("app_version", data.app_version);
        formData.append("appid", data.appid);
        formData.append("beta_version", data.beta_version);
        formData.append("description", data.description);
        formData.append("isavailable", data.isavailable);
        formData.append("title", data.title);
        formData.append("upgrade_min_api", data.upgrade_min_api);
        formData.append("upgrade_min_app_version", data.upgrade_min_app_version);
        formData.append("build", data.build);

        const requestOptions = {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("access_token")}`
            },
            body: formData
        };

        fetch(`${BASE_URL}/api/v1/app-management`, requestOptions)
            .then((data) => {
                setOpenBackDrop(false);
                if (data.status >= 200 && data.status < 300) {
                    notify('Your app was successfully built', { type: "info" });
                    navigate("/app-management");
                } else {
                    notify("Your app was  not successfully built", { type: "warning" });
                    navigate("/app-management");
                }
            });
    }

    return (
        <Box sx={{ pl: 6, pr: 3, pt: 12 }}>

            <Title title="App Management" />
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={6}>
                    <Grid item md={7}>
                        <Grid container spacing={2}>
                            <Grid item md={5}>
                                <TextField
                                    id="app_version"
                                    placeholder="Enter App Version"
                                    label="App Version"
                                    InputLabelProps={{ shrink: true }}
                                    {...register("app_version")}
                                    variant="outlined"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item md={3}>
                                <TextField
                                    id="appid"
                                    placeholder="Enter App Id"
                                    label="App Id"
                                    InputLabelProps={{ shrink: true }}
                                    {...register("appid")}
                                    variant="outlined"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item md={4}>
                                <TextField
                                    id="title"
                                    placeholder="Title"
                                    label="Title"
                                    InputLabelProps={{ shrink: true }}
                                    {...register("title")}
                                    variant="outlined"
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                        <Box sx={{ pb: 3 }}></Box>
                        <Grid container spacing={2}>
                            <Grid item xs={11} md={10}>
                                <TextField
                                    id="description"
                                    placeholder="Enter Description"
                                    label="Description"
                                    InputLabelProps={{ shrink: true }}
                                    {...register("description")}
                                    variant="outlined"
                                    fullWidth
                                    multiline
                                    rows={6}
                                />
                            </Grid>
                        </Grid>
                        <Box sx={{ pb: 3 }}></Box>
                        <Grid container spacing={3}>
                            <Grid item md={8}>
                                <Box sx={{display: 'flex'}}>
                                    <Box>
                                        <FormControlLabel
                                            control={<Checkbox checked={betaVersion} {...register("beta_version")} onChange={handleBetaVersion} name="beta_version" />}
                                            label="Beta Version"
                                        />
                                    </Box>
                                    <Box sx={{ marginLeft: 15 }}>
                                        <FormControlLabel
                                            control={<Checkbox checked={isAvailable} {...register("isavailable")} onChange={handleChangeIsAvailable} name="isavailable" />}
                                            label="Is Available"
                                        />
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                        <Box sx={{ pb: 3 }}></Box>
                        <Grid container spacing={2}>
                            <Grid item md={4}>
                                <TextField
                                    id="upgrade_min_api"
                                    placeholder="Upgrade Min Api"
                                    label="Upgrade Min Api"
                                    InputLabelProps={{ shrink: true }}
                                    {...register("upgrade_min_api")}
                                    variant="outlined"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item md={4}>
                                <TextField
                                    id="upgrade_min_app_version"
                                    placeholder="Upgrade Min App version"
                                    label="Upgrade Min App version"
                                    InputLabelProps={{ shrink: true }}
                                    {...register("upgrade_min_app_version")}
                                    variant="outlined"
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                        <Box sx={{ pb: 4 }}></Box>
                        <Grid container spacing={1}>
                            <Grid item md={12}>
                                {show ? <AndroidIcon /> : null}
                                <Button
                                    size="large"
                                    color="primary"
                                    component="label"
                                    style={{ marginTop: -10 }}
                                >
                                    Upload APK
                                    <input
                                        type="file"
                                        onChange={(e) => {
                                            handleAPK(e);
                                        }}
                                        hidden
                                    />
                                </Button>
                            </Grid>
                        </Grid>
                        <Box sx={{ p: 4 }}>
                            <Divider />
                        </Box>
                        <Button
                            size="large"
                            color="primary"
                            variant="contained"
                            type="submit"
                            onClick={handleSubmit(onSubmit)}
                        >
                            Submit
                        </Button>
                    </Grid>
                    <Grid item md={5}>

                    </Grid>
                </Grid>
                <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={openBackDrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            </form>
        </Box>
    )
}

export default Create;